import { render, staticRenderFns } from "./AddToCartDetails.vue?vue&type=template&id=a56d3a90&"
import script from "./AddToCartDetails.vue?vue&type=script&lang=js&"
export * from "./AddToCartDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports